import { useNavigate, Link } from "react-router-dom"
import { useLogout } from '../hooks/useLogout'
import { useAuthContext } from "../hooks/useAuthContext"
import { useState, useRef, useEffect } from 'react'

// styles and images
import styles from './Navbar.module.css'
import Logo from '../assets/Logo.svg'

export default function Navbar() {
  const DEVELOPER = 'OP14GJu-0725'
  const { logout, isPending } = useLogout()
  const { user, customClaims } = useAuthContext()
  const [searchQuery, setSearchQuery] = useState('')
  const [warning, setWarning] = useState('')

  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)
  const touchTimerRef = useRef(null)

  const navigate = useNavigate()

  const handleSearchSubmit = (e) => {
    e.preventDefault()
    
    if(searchQuery.trim()) {
      setSearchQuery('')
      if (searchQuery.length < 3) {
        setWarning('min 3 characters')
        return
      }
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`)
    }
  }

  // Toggle dropdown
  const toggleDropdown = () => {
    setIsOpen(!isOpen)
  }

  // Handle touch start - more responsive than touchEnd
  const handleTouchStart = (e) => {
    e.preventDefault()
    clearTimeout(touchTimerRef.current)
    toggleDropdown()
  }

  // close dropdown when click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('touchstart', handleClickOutside)
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('touchstart', handleClickOutside)
      clearTimeout(touchTimerRef.current)
    }
  }, [])
  
  return (
    <nav className={styles.navbar}>
      <ul>
        <li className={styles.logo}>
          <Link to="home">
            <img 
              src={Logo} 
              alt="Crifty Logo"
              width={150}
              height={75}
            />
          </Link>
        </li>
        {/**drop down menu. start */}
        {!user && (
          <>
            <li><Link to="login">Login</Link></li>
            <li><Link to="signup">Signup</Link></li>
          </>
        )}
        {user && (
          <>
            <form onSubmit={handleSearchSubmit}>
              <input
                name="search"
                type="text"
                placeholder={warning || "Search documents..."}
                aria-label="Search documents..."
                className={styles['search']}
                value={searchQuery}
                onChange={(e)=>setSearchQuery(e.target.value)}
              />
            </form>

            <li className={styles.dropdown} ref={dropdownRef}>
              {/* Add click/touch handlers to the title */}
              {/* Improved touch handling */}
              <div 
                className={styles['title-main']}
                onClick={toggleDropdown}
                onTouchStart={handleTouchStart}
                onTouchEnd={(e) => e.preventDefault()} // Prevent double trigger
                role="button"
                tabIndex={0}
                aria-haspopup="true"
                aria-expanded={isOpen}
              >
                &equiv; Start &equiv;
              </div>
              {/* Control visibility with isOpen state */}
              <div 
                className={styles.dropdownMenu}
                style={{ display: isOpen ? 'block' : 'none' }}
              >
                <ul>
                  <div className={styles['myinfo']}>
                    <div className={styles['split']}>
                      <li>
                        <Link 
                          className={styles['title']} 
                          to="myinfo" 
                          onClick={()=>setIsOpen(false)}
                        >{user.displayName}
                        </Link>
                      </li>
                      <li>
                        <Link 
                          to="myinfo" 
                          onClick={()=>setIsOpen(false)}
                        >{user.email}
                        </Link>
                      </li>
                    </div>
                    <div className={styles['split']}>
                      <li>
                        {!isPending && <button className="small-btn" onClick={logout}>Logout</button>}
                        {isPending && <button className="small-btn">Logging out...</button>}
                      </li>
                    </div>
                  </div>
                  
                  <div className={styles['navigation-menu']}>
                    <li>
                      <Link 
                        className={styles['title']} 
                        to="dashboard" 
                        onClick={()=>setIsOpen(false)}
                      >Dashboard
                      </Link>
                    </li>
                    <li>
                      <Link 
                        className={styles['title']} 
                        to="progress" 
                        onClick={()=>setIsOpen(false)}
                      >Project
                      </Link>
                    </li>
                    {(user && customClaims.tenantId === DEVELOPER) && <>
                      {/*<li>
                        <Link 
                          className={styles['title']} 
                          to="progress" 
                          onClick={()=>setIsOpen(false)}
                        >Project
                        </Link>
                      </li>*/}
                      <li>
                        <Link 
                          className={styles['title']} 
                          to="developer" 
                          onClick={()=>setIsOpen(false)}
                        >Developer
                        </Link>
                      </li>
                    </>}
                    <li>
                      <Link 
                        className={styles['title']} 
                        to="document"
                        onClick={()=>setIsOpen(false)}
                      >Add a Document
                      </Link>
                    </li>
                    <li>
                      <Link 
                        className={styles['title']} 
                        to="contactbook"
                        onClick={()=>setIsOpen(false)}
                      >Contact Book
                      </Link>
                    </li>
                    <li>
                      <Link 
                        className={styles['title']} 
                        to="pnsbook"
                        onClick={()=>setIsOpen(false)}
                      >Product List
                      </Link>
                    </li>

                  </div>
                </ul>
              </div>
              
            </li>
          </>
        )}
      </ul>
      <div className={styles['horizontal-line']}></div>
    </nav>
  )
}